<template>
  <div>
    <div v-if="getTransactionError" style="margin:auto" :style="{ width: $vuetify.breakpoint.smAndDown ? '80vw' : '50vw' }">
      <h2 class="pb-3">Срок хранения сессии подписания завершён.</h2>
      <p>Все данные сессии: ФИО и ID участников, документы и другие служебные данные безвозвратно удалены.</p>
      <p>Результат завершения сессии подписания был направлен всем участникам соответствующим образом.</p>
    </div>
    <LeftPanel v-if="showLeftPanel" />
    <component :is="currentStepComponent()" v-if="!getTransactionError" @confirmed="phoneLikeUserAgreed = true"/>
    <!-- <v-snackbar v-model="getTransactionError" :timeout="timeout" color="error">
      Сессия не найдена. Попробуйте обновить страницу.
      <v-btn text icon @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar> -->
  </div>
</template>

<script>
  import ConfirmationForm from '@/components/ConfirmationForm'
  import StatusPage from '@/components/StatusPage'
  import { currentUserData } from '@/utils/usersLegacy'
  import { actorByPreactor, hasStage, isApprover, isSigner } from '@/utils/transactionLegacy'
  import { SignatureStage } from '@/models/TransactionData'
  import { phoneLikeIdentities } from '@/models/digitalIdentities'
  import PhoneInfoAgreementPage from '@/components/ConfirmationForm/PhoneInfoAgreementForm.vue'
  import LeftPanel from '@/components/pdfFormViewComponents/pdfForm/leftPanelComponents/LeftPanel.vue';
  import eventBus from '@/utils/eventBus';

  export default {
    name: 'Confirmation',
    components: {
      LeftPanel,
    },
    data() {
      return {
        overlay: false,
        getTransactionError: false,
        timeout: 5000,
        transaction: null,
        phoneLikeUserAgreed: false,
      }
    },

    computed: {
      sessionId() {
        return this.$route.params.id
      },
      senderId() {
        return this.$route.params.uid
      },
      confirmationCondition() {
        return isSigner(this.transaction, currentUserData.contact)
          && !hasStage(this.transaction, currentUserData, SignatureStage.signed)
          && !hasStage(this.transaction, currentUserData, SignatureStage.signingRejected)
      },
      phoneLikeInfoCondition() {
        return phoneLikeIdentities.includes(currentUserData?.source) && !this.phoneLikeUserAgreed
      },
      showLeftPanel() {
        return this.currentStepComponent() === ConfirmationForm;
      },

      currentStep() {
        if (!this.transaction || !currentUserData) return ''
        const currentStep = this.transaction.status || ''
        if (currentStep === 'AwaitingInnerSignatures' || currentStep === 'AwaitingSignatures') {
          if (this.confirmationCondition && this.phoneLikeInfoCondition) return 'PhoneInfoAgreementPage'
          else if (this.confirmationCondition && this.phoneLikeUserAgreed) return 'ConfirmationForm'
          else if (this.confirmationCondition) return 'PhoneInfoAgreementPage'
          else if (isApprover(this.transaction, currentUserData.contact) &&
            !hasStage(this.transaction, actorByPreactor(this.transaction, currentUserData.contact), SignatureStage.signing)) return 'ConfirmationForm'
          else return 'StatusPage'
        } else return 'StatusPage'
      },
    },

    watch: {
      currentStep: {
        immediate: true,
        handler(newStep) {
          eventBus.$emit('confirmation-step-changed', newStep)
        }
      }
    },

    async created() {
      await this.uploadTransaction()
      this.transaction = JSON.parse(
        JSON.stringify(this.$store.getters.transaction),
      )
    },

    methods: {
      currentStepComponent() {
        const stepName = this.currentStep
        switch (stepName) {
          case 'PhoneInfoAgreementPage': return PhoneInfoAgreementPage
          case 'ConfirmationForm': return ConfirmationForm
          case 'StatusPage': return StatusPage
          default: return null
        }
      },
      async uploadTransaction() {
        this.overlay = true
        const { sessionId, senderId } = this
        const res = await this.$store.dispatch('uploadTransaction', {
          sessionId,
          senderId,
        })
        if (res) {
          this.overlay = false
        } else {
          this.getTransactionError = true
          this.overlay = false
        }
      },
    },
  }
</script>